import { Box, HStack, Link, Text, VStack } from "@chakra-ui/react";

import CategoryTag from "./tags/category-tag";
import React from "react";
import { shortenExcerptText } from "../../utils/text-utils";

function SingleBlogCard({
  isResurs,
  href,
  date,
  title,
  excerpt,
  imageUrl,
  category,
  tag,
}: SingleBlogCardProps) {
  const shortExcerpt = shortenExcerptText(excerpt, 80);
  const shortTitle = shortenExcerptText(title, 60);
  return (
    <>
      <Box>
        <Link href={href} aria-label={"Blog post" + href}>
          <Box
            position="relative"
            w={
              isResurs
                ? { base: "100%", xl: "100%" }
                : { base: "100%", xl: "413px" }
            }
            h={isResurs ? "202px" : "275px"}
            backgroundImage={
              imageUrl
                ? imageUrl
                : "https://www.svetionikznanja.afirmacijakulture.org/wp-content/uploads/sites/3/sites/3/2024/10/ogimage.webp"
            }
            backgroundRepeat="no-repeat"
            backgroundPosition="center"
            backgroundSize="cover"
            borderRadius="3xl"></Box>
        </Link>
        <VStack alignItems="flex-start" p="12px 8px" gap="10px">
          {isResurs && (
            <HStack>
              {category.map((item: any, index: number) => {
                return <CategoryTag key={index} catName={item} />;
              })}
            </HStack>
          )}
          <Link
            href={href}
            aria-label={"Blog post" + href}
            fontSize="20px"
            fontWeight="600"
            lineHeight="120%">
            {shortTitle}
          </Link>
          <Text fontSize="12px" color="#A0AEC0" margin="0px !important">
            {date}
          </Text>
          <Text
            dangerouslySetInnerHTML={{ __html: shortExcerpt }}
            color="#4A5568"
            lineHeight="150%"
            margin="0px !important"></Text>
        </VStack>
      </Box>
    </>
  );
}

type SingleBlogCardProps = {
  isResurs?: boolean;
  href: string;
  date: string;
  title: string;
  excerpt: string;
  imageUrl: string;
  category?: any;
  tag: any;
};

export default SingleBlogCard;
